import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Companion_getInstance13wwf84j92s7c as Companion_getInstance } from '../../../../../ktor-ktor-http/io/ktor/http/HttpMethod.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { KtMutableList1beimitadwkna as KtMutableList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { PrimitiveClasses_getInstanceds06xwqrwfdm as PrimitiveClasses_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/primitives.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  createKType31ecntyyaay3k as createKType,
  createInvariantKTypeProjection3h5364czc0a8w as createInvariantKTypeProjection,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { TypeInfo2nbxsuf4v8os2 as TypeInfo } from '../../../../../ktor-ktor-utils/io/ktor/util/reflect/Type.mjs';
import { AttributeKey3aq8ytwgx54f7 as AttributeKey } from '../../../../../ktor-ktor-utils/io/ktor/util/Attributes.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_DecompressionListAttribute() {
  _init_properties_HeadersUtils_kt__fb6dxx();
  return DecompressionListAttribute;
}
var DecompressionListAttribute;
function dropCompressionHeaders(_this__u8e3s4, method, attributes, alwaysRemove) {
  alwaysRemove = alwaysRemove === VOID ? false : alwaysRemove;
  _init_properties_HeadersUtils_kt__fb6dxx();
  if (method.equals(Companion_getInstance().h56_1) || method.equals(Companion_getInstance().i56_1))
    return Unit_instance;
  var header = _this__u8e3s4.d2p('Content-Encoding');
  if (header == null) {
    if (!alwaysRemove)
      return Unit_instance;
  } else {
    var tmp = get_DecompressionListAttribute();
    attributes.p4r(tmp, dropCompressionHeaders$lambda).i2(header);
  }
  _this__u8e3s4.b4u('Content-Encoding');
  _this__u8e3s4.b4u('Content-Length');
}
function dropCompressionHeaders$lambda() {
  _init_properties_HeadersUtils_kt__fb6dxx();
  // Inline function 'kotlin.collections.mutableListOf' call
  return ArrayList().p2();
}
var properties_initialized_HeadersUtils_kt_8c3zal;
function _init_properties_HeadersUtils_kt__fb6dxx() {
  if (!properties_initialized_HeadersUtils_kt_8c3zal) {
    properties_initialized_HeadersUtils_kt_8c3zal = true;
    // Inline function 'io.ktor.util.AttributeKey' call
    var name = 'DecompressionListAttribute';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp = getKClass(KtMutableList());
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_0;
    try {
      tmp_0 = createKType(getKClass(KtMutableList()), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().cg(), arrayOf([]), false))]), false);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_1 = null;
      } else {
        throw $p;
      }
      tmp_0 = tmp_1;
    }
    var tmp$ret$2 = tmp_0;
    var tmp$ret$1 = new (TypeInfo())(tmp, tmp$ret$2);
    DecompressionListAttribute = new (AttributeKey())(name, tmp$ret$1);
  }
}
//region block: exports
export {
  dropCompressionHeaders as dropCompressionHeaders12falb2m2fkr1,
};
//endregion

//# sourceMappingURL=HeadersUtils.mjs.map
